'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Uses React Modal - https://github.com/reactjs/react-modal
 */
var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var appElement = this.props.appElement;


      if (appElement) {
        _reactModal2.default.setAppElement(appElement);
      }

      this.calculateDocumentScroll(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isOpen !== this.props.isOpen) {
        this.calculateDocumentScroll(nextProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.calculateDocumentScroll({ isOpen: false });
    }
  }, {
    key: 'calculateDocumentScroll',
    value: function calculateDocumentScroll(props) {
      if (!props.enableDocumentScroll) {
        window.document.body.style.overflow = props.isOpen ? 'hidden' : 'auto';
        window.document.documentElement.style.overflow = props.isOpen ? 'hidden' : 'auto';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          appElement = _props.appElement,
          children = _props.children,
          closeIcon = _props.closeIcon,
          classNames = _props.classNames,
          styles = _props.styles,
          props = _objectWithoutProperties(_props, ['appElement', 'children', 'closeIcon', 'classNames', 'styles']);

      return _react2.default.createElement(
        _reactModal2.default,
        _extends({
          style: {
            overlay: styles.overlay,
            content: styles.content
          },
          className: {
            base: 'c11n-modal',
            afterOpen: 'c11n-modal-after-open',
            beforeClose: 'c11n-modal-before-close'
          },
          overlayClassName: {
            base: 'c11n-modal-overlay',
            afterOpen: 'c11n-modal-overlay-after-open',
            beforeClose: 'c11n-modal-overlay-before-close'
          }
        }, props),
        closeIcon && _react2.default.createElement('button', {
          className: classNames.close,
          onClick: props.onRequestClose,
          'aria-label': 'Close',
          children: closeIcon
        }),
        _react2.default.createElement(
          'div',
          { className: classNames.container },
          children
        )
      );
    }
  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  /**
   * A valid query selector for the element your React app is mounted to
   */
  appElement: _propTypes2.default.string,

  /**
   * The content of the modal
   */
  children: _propTypes2.default.any.isRequired,

  /**
   * Number indicating the milliseconds to wait before closing the modal.
   */
  closeTimeoutMS: _propTypes2.default.number,

  /**
   * A react-modal required prop for accessibility
   */
  contentLabel: _propTypes2.default.string.isRequired,

  /**
   * The close icon (set to false to hide)
   */
  closeIcon: _propTypes2.default.any,

  /**
   * Specifies whether the modal is open or not
   */
  isOpen: _propTypes2.default.bool,

  /**
   * Function that will be run after the modal has opened.
   */
  onAfterOpen: _propTypes2.default.func,

  /**
   * The callback to call when the modal should be closed
   */
  onRequestClose: _propTypes2.default.func,

  /**
   * Specifies whether the modal closes on clicking overlay
   */
  shouldCloseOnOverlayClick: _propTypes2.default.bool,

  /**
   * A spacing object to determine the padding within the modal
   */
  spacing: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.number]),

  /**
   * Custom styles for the overlay, content, container or close
   */
  styles: _propTypes2.default.object,

  /**
   * Enable scroll of document when modal is open
   */
  enableDocumentScroll: _propTypes2.default.bool
};

Modal.defaultProps = {
  appElement: '#mount',
  closeIcon: _react2.default.createElement(_icon2.default, { name: 'close' }),
  shouldCloseOnOverlayClick: true,
  spacing: 1,
  styles: {}
};

exports.default = (0, _withStyles2.default)(_styles2.default)(Modal);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/modal/index.js
// module id = 857
// module chunks = 0